import React, {
  useEffect,
} from 'react';
import {
  useFormContext,
} from 'react-hook-form';
import {
  isEmptyString,
} from '@populateui/utils';
import FormTextField from 'views/EMR/components/FillableForm/components/FormTextField';
import {
  FieldComponentProps,
} from 'views/EMR/components/FillableForm/types';

export default function SignatureInput({
  field,
  value,
  onChange,
}: FieldComponentProps) {
  const { watch } = useFormContext();
  const signature = watch(field?.type ?? '');

  function onSignatureChange(data: string) {
    onChange?.({ ...value, value: data });
  }

  useEffect(() => {
    if (!isEmptyString(signature)) {
      onSignatureChange(signature as string);
    }
  }, [signature, field?.id]);

  const isImageSignature = typeof signature === 'string' && signature?.startsWith('data:image');

  return isImageSignature ? (
    <div className="w-full border rounded bg-gray-50">
      <img
        src={signature}
        alt="signature"
        className="max-h-10 object-contain"
      />
    </div>
  ) : (
    <FormTextField
      id={field?.id ?? ''}
      key={field?.id ?? ''}
      fullWidth
      placeholder="Please enter a value"
      value={(signature ?? '') as string}
      disabled={!isEmptyString(signature)}
      onChange={(e) => {
        onSignatureChange(e.target.value);
      }}
      slotProps={{
        input: {
          className: 'text-[#345D7E] dancing-script-regular',
        },
      }}
    />
  );
}
